import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { useData } from '../../contexts/DataContext';
import { DocumentTypeApi } from '../../services/ApiService';

function DocumentTypeList() {
  // const { getDocumentTypes } = useData();
  
  const [documentTypes, setDocumentTypes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadDocumentTypes = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await DocumentTypeApi.getDocumentTypes();
      if (!res.ok) throw new Error(`Failed to load document types: ${res.status}`);
      const data = await res.json();
      setDocumentTypes(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error loading document types:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDocumentTypes();
  }, [loadDocumentTypes]);

  const handleRefresh = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await DocumentTypeApi.getDocumentTypes();
      if (!res.ok) throw new Error(`Failed to refresh document types: ${res.status}`);
      const data = await res.json();
      setDocumentTypes(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error refreshing document types:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (documentTypeId, documentTypeName) => {
    if (!window.confirm(`Are you sure you want to delete the document type "${documentTypeName}"? This action cannot be undone.`)) {
      return;
    }

    try {
      const response = await DocumentTypeApi.deleteDocumentType(documentTypeId);
      if (!response.ok) {
        throw new Error('Failed to delete document type');
      }
      await handleRefresh();
    } catch (err) {
      console.error('Error deleting document type:', err);
      alert('Failed to delete document type. Please try again.');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredDocumentTypes = documentTypes.filter(docType =>
    docType.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    docType.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="settings-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading document types...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-theme-panel" style={{display:'flex',flexDirection:'column',gap:'var(--space-md)'}}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{margin:0,fontSize:'1.1rem'}}>Document Types</h2>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button 
            type="button" 
            onClick={handleRefresh}
            className="btn-outline btn-sm"
          >
            Refresh
          </button>
          <Link to="/settings/document-types/create">
            <button type="button" className="btn-primary btn-sm">Create New Type</button>
          </Link>
        </div>
      </div>
      
      {error && (
        <div className="error-message">
          Failed to load document types: {error.message || 'Unknown error'}
        </div>
      )}

      <div>
        <input
          type="text"
          placeholder="Search document types..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="tp-input"
          style={{width:'100%'}}
        />
      </div>

      {filteredDocumentTypes.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          {searchTerm ? (
            <>
              <h3>No document types found</h3>
              <p>Try adjusting your search term or create a new document type.</p>
            </>
          ) : (
            <>
              <h3>No document types available</h3>
              <p>Get started by creating your first document type.</p>
            </>
          )}
        </div>
      ) : (
        <div className="settings-theme-table-wrapper"><table className="settings-theme-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Metadata Fields</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredDocumentTypes.map((docType) => (
              <tr key={docType.id}>
                <td>
                  <strong>{docType.name}</strong>
                </td>
                <td>{docType.description || '—'}</td>
                <td>
                  {docType.metadataDefinitions?.length || 0} field{docType.metadataDefinitions?.length !== 1 ? 's' : ''}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Link to={`/settings/document-types/${docType.id}`}>
                      <button className="btn-outline btn-sm">Edit</button>
                    </Link>
                    <Link to={`/settings/document-types/${docType.id}/assign-fields`}>
                      <button className="btn-neutral btn-sm">Fields</button>
                    </Link>
                    <button
                      onClick={() => handleDelete(docType.id, docType.name)}
                      className="btn-danger btn-sm"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      )}
    </div>
  );
}

export default DocumentTypeList;